<template>
  <div class="container">
    <div class="mb-8">  
      <slot name="heading"></slot>
      <p class="text-black-light-5 mb-4">
        At ZuBlu, we love to showcase the best resorts, liveaboards, and tour operators across Asia and beyond. If you would like to partner with us, please get in touch.
      </p>
      <Link text="back to booking enquiry" :leftIcon="true" href="/enquiry" @click="onBack" />
    </div>
    <div class="enquiry-form">
      <validation-observer tag="div" ref="valiObjserver">
        <form @submit.prevent="onBeforeSubmit">
          <label class="block mb-8">
            <p class="mb-2 fs-14">First name</p>
            <validation-provider ref="First Name" name="First Name" rules="required" v-slot="{ errors }">
              <input
                class="input input-tall w-full"
                :class="{ 'input--error': errors[0] }"
                v-model="firstName" />
              <span class="fs-14 text-danger mt-1">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <label class="block mb-8">
            <p class="mb-2 fs-14">Last name</p>
            <validation-provider ref="Last Name" name="Last Name" rules="required" v-slot="{ errors }">
              <input
                class="input input-tall w-full"
                :class="{ 'input--error': errors[0] }"
                v-model="lastName" />
              <span class="fs-14 text-danger mt-1">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <label class="block mb-8">
            <p class="mb-2 fs-14">Email</p>
            <validation-provider ref="Email" name="Email" rules="required|email" v-slot="{ errors }">
              <input
                class="input input-tall w-full"
                :class="{ 'input--error': errors[0] }"
                v-model.lazy="email" />
              <span class="fs-14 text-danger mt-1">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <label class="block mb-8 w-4/5 sm:w-full">
            <p class="mb-2 fs-14">Phone</p>
            <validation-provider ref="Phone" name="Phone" rules="required" v-slot="{ errors }">
              <phone-input
                class="input input-tall w-full"
                :class="{ 'input--error': errors[0] }"
                v-model="phone" />

              <span class="fs-14 text-danger mt-1">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <label>
            <p class="mb-2 fs-14">Message</p>
            <textarea
              class="input w-full enquiry-additional-request"
              v-model="additionalMessage"
            />
          </label>

         <button class="mt-8 btn btn-primary input-tall font-medium sm:w-full sm:justify-center flex items-center"
            :disabled="isWorking" :class="isWorking ? 'loading' : ''">
            Enquire
            <div class="zb-spin"></div>
          </button>
        </form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  setInteractionMode
} from 'vee-validate'
import { required, email, min_value } from 'vee-validate/dist/rules'
import Tooltip from '../../components/core/Tooltip'
import PhoneInput from '../../components/core/PhoneInput'
import Link from '../../components/core/Link';
const fieldsOrder = [
  'First Name', 'Last Name', 'Email', 'Phone', 'Message'
]

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    PhoneInput,
    Link
  },
  name: 'Enquiry',
  props: {
    onBack: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      isWorking: false,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      additionalMessage: '',
      formSubmitted: false
    }
  },
  methods: {
    onBeforeSubmit () {
      const valid = this.$refs.valiObjserver.validate()
        .then((result) => {
          if (result === false) {
            setTimeout(() => {
              const errors = JSON.parse(JSON.stringify(this.$refs.valiObjserver.errors))

              for (const field of fieldsOrder) {
                if (errors[field] && errors[field].length) {
                  this.$refs[field].$el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  })
                  break
                }
              }
            }, 100) //https://github.com/logaretm/vee-validate/issues/2248
          }
          else {
            this.onSubmit()
          }
        })
    },
    onSubmit () {
      this.formSubmitted = true
      
      const form = document.getElementById('form')
      const thankyou = document.getElementById('thankyou')
      const thankyoumessage = document.getElementById('thankyoumessage')

      const payload = {
        'first_name': this.firstName,
        'last_name': this.lastName,
        'email': this.email,
        'phone': this.phone,
        'message': this.additionalMessage,
        'type': 'partner'
      }

      this.isWorking = true

      $.ajax({
        method: 'POST',
        url: `${window.ZUBLU_VARIABLES.OCTOBOX_API}/api/contact-us`,
        data: payload,
        headers: {
          'Authorization': 'Basic ZGV2ZWxvcG1lbnRAenVibHVkaXZpbmcuY29tOmRldjEyMzQ1',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .done(() => {
        thankyoumessage.innerText = `Thank you for getting in touch, ${this.firstName}.`
        form.classList.add('hidden')
        window.scrollTo(0, thankyou)
        thankyou.classList.remove('hidden')
      })
      .fail((e) => {
        console.log(e)
        this.isWorking = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  .zb-spin {
    display: none;
  }
  &.loading {
    .zb-spin {
      display: inline-block;
    }
  }
}
</style>
